import { CONTEXT_QUERY_PARAM } from '@constants/query-params';
import { useGenericQuery } from '@hooks/use-generic-query';
import { GenericQueryOptions } from '@hooks/use-generic-query.type';
import { request } from '@utils/request/request';
import { RequestError, RequestMethod } from '@utils/request/request.type';

import { QUERY_KEYS } from './constants.type';
import type { GetCompanyPassesResponse, Params } from './use-get-company-passes.type';

export const getCompanyPassesQueryKey = (companyId: string, params?: Params) => [
  QUERY_KEYS.getCompanyPasses,
  companyId,
  params,
];

const getCompanyPasses = async ({ companyId = '', params }: { companyId?: string; params?: Params }) => {
  const searchParams = new URLSearchParams({ limit: '100' });

  if (params?.validFrom !== undefined) searchParams.set('validFrom', String(params.validFrom));
  if (params?.validUntil !== undefined) searchParams.set('validUntil', String(params.validUntil));
  if (params?.status?.length) params.status.forEach((s) => searchParams.append('status[]', s));
  if (params?.orderBy) searchParams.set('orderBy', params.orderBy);
  if (params?.sort) searchParams.set('sort', params.sort);
  if (params?.context) searchParams.set(CONTEXT_QUERY_PARAM, params.context);

  const url = `${import.meta.env.VITE_OFFERS_HOST}/v1/nightgraph/companies/${companyId}/passes?${searchParams.toString()}`;

  return request({ url, method: RequestMethod.GET });
};

export const useGetCompanyPasses = ({
  companyId = '',
  params,
  enabled,
  options,
}: {
  companyId?: string;
  params?: Params;
  enabled: boolean;
  options?: GenericQueryOptions<GetCompanyPassesResponse, RequestError>;
}) => {
  return useGenericQuery<GetCompanyPassesResponse, RequestError>(
    getCompanyPassesQueryKey(companyId, params),
    () => getCompanyPasses({ companyId, params }),
    { ...options, enabled }
  );
};
